import React, { useEffect } from "react";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import KindergartenComponentLegacy from "../../../components/applicationComponents/legacy/kindergarten/KindergartenComponentLegacy";

export default function KindergartenPageLegacy() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Kindergarten Details",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return <KindergartenComponentLegacy disabled={false} />;
}
